<template>
  <div class="margin">
    <label>
      <span class="title">{{ title }}</span>
      <span class="required" v-if="required">*</span>
      <Tip :field="field" :formName="formName" />
    </label>
    <div class="select" :class="{
      'select-invalid': notifications.length > 0 && formDirty,
      border: showBorder,
    }">
      <multiselect @open="onOpen" @select="onSelected" @search-change="onSearch" :options="data"
        v-model.trim="currentValue" :custom-label="label" placeholder :disabled="disabled" :showLabels="true"
        :noResult="false" :maxHeight="250" ref="multiselect" selectLabel deselectLabel selectedLabel>
        <div slot="beforeList">
          <vue-loading v-if="loading" type="bubbles" color="#577696"
            :size="{ width: '40px', height: '40px' }"></vue-loading>
          <div class="before-list" v-if="!loading">
            <Button v-if="showNewRegister" key="addNewRegister" type="primary" :title="labelNewRegister" size="small"
              :clicked="addNewRegister" />
            <Button key="cleanSelect" title="Limpar" type="warning" classIcon="fas fa-broom" size="small"
              :clicked="cleanSelect" />
          </div>
        </div>
        <div slot="afterList" v-if="totalRecords > 20 && data.length < totalRecords">
          <div class="after-list text-center">
            <Button key="loadingMore" type="info" title="Carregar mais..." classIcon="fas fa-redo-alt" size="small"
              :clicked="loadingMore" />
          </div>
        </div>
        <div slot="noOptions">Lista está vazia</div>
        <div slot="noResult">Nenhum registro encontrado</div>
      </multiselect>
      <div v-if="formDirty">
        <div v-for="message in notifications" :key="message">
          <span class="invalid">{{ message }}</span>
        </div>
      </div>
    </div>

    <vodal v-if="nameNewRegister" :duration="50" :show="showVodal(nameNewRegister)" @hide="hide()"
      :width="widthNewRegister" :height="heightNewRegister" :closeOnEsc="true" :closeButton="true">
      <Messages v-if="vodal.open" />
      <div class="select-vodal">
        <div class="title-new-form">{{ titleNewRegister }}</div>
        <slot></slot>
      </div>
    </vodal>
  </div>
</template>
<script>
import Tip from "../shared/Tip.vue";
import Messages from "../shared/Messages.vue";
import Multiselect from "vue-multiselect";

import Button from "./Button.vue";
import Vodal from "vodal";

import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "Select",
  props: {
    title: String,
    field: String,
    formName: String,
    required: Boolean,
    url: String,
    disabled: Boolean,
    initialFieldTarget: String,
    fieldTarget: String,
    propsParams: Object,
    value: Object,
    changed: Function,
    cleaned: Function,
    nameNewRegister: String,
    showNewRegister: {
      type: Boolean,
      default: true,
    },
    clickedNewRegister: Function,
    titleNewRegister: String,
    labelNewRegister: {
      type: String,
      default: "Novo",
    },
    widthNewRegister: Number,
    heightNewRegister: Number,
    markFormDirty: {
      type: Boolean,
      default: true,
    },
    showBorder: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Multiselect,
    Button,
    Vodal,
    Messages,
    Tip,
  },
  data() {
    return {
      currentValue: {},
      data: [],
      totalRecords: 0,
      baseParams: {
        search: "",
        currentPage: 1,
        totalPerPage: 20,
      },

      registerNew: false,
      loading: true,
      notifications: [],
      formDirty: false,
      names: [],
    };
  },
  created() {
    this.validate();
    if (this.value)
      this.currentValue = { id: this.value.id, content: this.value.content };
  },
  mounted() {
    let el = this.$el.getElementsByClassName("multiselect")[0];
    if (el) {
      el.tabIndex = 0;
    }
  },
  computed: {
    ...mapState("validation", ["resetForm", "vodal"]),
    ...mapState("generic", ["vodal"]),
    ...mapGetters("generic", ["showVodal", "event"]),
  },
  methods: {
    ...mapActions("generic", ["getApi"]),
    ...mapMutations("generic", [
      "removeLoading",
      "openVodal",
      "hideVodal",
      "removeNotificarions",
      "addFilter",
    ]),
    ...mapMutations("validation", [
      "addValidation",
      "removeValidation",
      "resetValidation",
      "updateFormDirty",
    ]),
    onOpen() {
      this.getAll();
    },
    onSelected(value) {
      this.$emit("input", value);
      if (this.changed) this.changed();
      if (this.fieldTarget) {
        let obj = {
          tag: `${this.title}: ${value.content}`,
          fieldTarget: this.fieldTarget,
          value: value.id,
        };
        this.addFilter(obj);
      }
    },
    onSearch(value) {
      this.baseParams.search = value;
      this.getAll();
    },
    label(value) {
      if (value.content) return `${value.content}`;
    },
    getAll() {
      let obj = { ...this.baseParams, ...this.propsParams };
      let params = { url: this.url, obj: obj };
      this.loading = true;
      this.getApi(params).then((response) => {
        this.totalRecords = response.content.totalRecords;
        let self = this;
        if (this.baseParams.currentPage == 1) {
          this.data = [];
        }
        (response.content.data || response.content.items).map(function (value, key) {
          self.data.push(value);
        });
        this.loading = false;
        this.removeLoading(["loadingMore"]);
      });
    },
    addNewRegister() {
      if (this.clickedNewRegister) {
        this.clickedNewRegister();
      } else {
        this.openVodal(this.nameNewRegister);
        this.resetValidation(this.nameNewRegister);
        this.removeNotificarions();
        this.$refs.multiselect.deactivate();
        this.removeLoading(["addNewRegister"]);
      }
    },
    hide() {
      this.hideVodal(this.nameNewRegister);
    },
    cleanSelect() {
      let obj = { id: "", content: "" };
      this.currentValue = obj;
      this.$emit("input", obj);
      this.$refs.multiselect.deactivate();
      this.removeLoading(["cleanSelect"]);

      if (this.fieldTarget) {
        let obj = { fieldTarget: this.fieldTarget, value: "" };
        this.addFilter(obj);
      }

      if (this.cleaned) this.cleaned();
    },
    loadingMore() {
      this.baseParams.currentPage++;
      this.getAll();
    },
    validate() {
      this.notifications = [];
      if (this.required && !this.value.id) {
        var message = `${this.title} não pode ser vazio!`;
        this.notifications.push(message);
      }
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "tagRemoved") {
          if (this.fieldTarget == event.data) this.cleanSelect();
        }
      },
      deep: true,
    },
    "value.id": function () {
      this.validate();
      this.formDirty = true;
      if (this.markFormDirty) this.updateFormDirty(true);
      this.currentValue = { id: this.value.id, content: this.value.content };
    },
    notifications() {
      let self = this;
      this.notifications.forEach(function (notification) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
          notification: notification,
        };
        self.addValidation(obj);
      });

      if (this.notifications.length == 0) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
        };
        self.removeValidation(obj);
      }
    },
    resetForm: {
      handler(form) {
        if (form.name == this.formName) {
          let obj = { id: "", content: "" };
          this.currentValue = obj;
          this.$emit("input", obj);
          this.formDirty = false;
        }
      },
      deep: true,
    },
    "vodal.open": function (value) {
      if (!value) this.registerNew = false;
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #0a0a0a;
  letter-spacing: 0.5px !important;
}

.margin {
  margin-bottom: 10px;
}

div.before-list {
  padding: 8px;
}

div.after-list {
  padding: 8px;
}

.invalid {
  color: #f0134d;
  font-size: 14px;
}

.select {
  min-width: 300px;
  height: 36px;
  border-bottom: 1px solid #d6dadf;
  border-radius: 0px !important;
  z-index: 100;
}

.select-invalid {
  border-bottom: 1px solid #ff5454;
}

.select-valid {
  border-bottom: 1px solid #94aa2a;
}

.title-new-form {
  font-size: 18px;
  margin-bottom: 5px;
}

.border {
  border: 1px solid #dbdee0 !important;
  border-radius: 5px !important;
  height: 38px !important;
}

.select-vodal {
  padding: 10px;
}
</style>
